// @vendors
const { Promise } = require('es6-promise');

// @helpers
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');

// @constants
const { BROKER_ALERT_PAGE_NUM, BROKER_ALERT_PAGE_SIZE } = require('constants/index');
const actionTypes = require('constants/actionTypes');

const requestBuyButtonUrl = (response, dispatch, getState) => {
    const immAlert = getState().brokerAlerts;
    const url = apiURLBuilder.getURL('medysifStock');
    const requestData = {
        exchangeId: immAlert.get('exchangeId') ? immAlert.get('exchangeId') : response[0].exchangeId,
        spcSymbol: immAlert.get('spcSymbol') ?  immAlert.get('spcSymbol') : response[0].spcSymbol,
        pageNum: BROKER_ALERT_PAGE_NUM,
        pageSize: BROKER_ALERT_PAGE_SIZE
    };

    APIGet(dispatch, url, { query: requestData }).then((res) => {
        dispatch({
            type: actionTypes.BROKER_GET_ALERTS_BUY,
            payload: { res }
        });
    });
};

function requestAlertsFetching() {
    return {
        type: actionTypes.BROKER_GET_ALERTS_FETCHING
    };
}

function requestAlertsSuccess(response) {
    return {
        type: actionTypes.BROKER_GET_ALERTS_SUCCESS,
        payload: {
            data: response
        }
    };
}

function requestAlertsFailure(response) {
    return {
        type: actionTypes.BROKER_GET_ALERTS_FAILURE,
        payload: {
            data: response
        }
    };
}


function requestAlerts(dispatch, state, callback) {
    return new Promise(function () {

        const queryData = {
            query: {
                limitRecords: 3,
                pageNum: BROKER_ALERT_PAGE_NUM,
                pageSize: BROKER_ALERT_PAGE_SIZE
            }
        };

        dispatch(requestAlertsFetching());
        return APIGet(dispatch, apiURLBuilder.getURL('brokerAlerts'), queryData)
            .then(function(response) {
                return callback(response||[]);
            }, function(response) {
                dispatch(requestAlertsFailure(response));
            }
        );
    });
}

function getAlertsAction(dispatch, state) {
    return requestAlerts(dispatch, state, function(response) {
        dispatch(requestAlertsSuccess(response));
        if (response && response.length) {
            requestBuyButtonUrl(response, dispatch, state);
        }
    });
}

const getAlerts = () => (dispatch, state) => (getAlertsAction(dispatch, state));

module.exports = {
    getAlerts
};
